import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import DivisionsSection from './components/DivisionsSection';
import DifferentiatorsSection from './components/DifferentiatorsSection';

export default function Home() {
  useEffect(() => {
    document.title = 'Holston Development Group';
  }, []);

  return (
    <div className="min-h-screen font-[\'Manrope\',sans-serif]">
      <Navbar />
      <main>
        <HeroSection />
        <IntroSection />
        <DivisionsSection />
        <DifferentiatorsSection />
      </main>
      <Footer />
    </div>
  );
}
